import { formatMoney } from '@shopify/theme-currency'

export function productPrice (price) {
  return formatMoney(price, window.theme.shop.moneyFormat)
}

export function productPointsValue (price) {
  const points = (price / 100) * window.theme.elite.pointsPerPound
  return `${Math.floor(points)} Points`
}
